module.exports = __webpack_public_path__ + "img/XLAB.4beffb77.png";